export const MarketingClientCustomDataLayerConstants = {
    customDataLayer: "customDataLayer",
    displayAttribute: "Display"
};
